import { defineStore } from 'pinia'

import { Ref, ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'

import { OktellClient } from '@/core/types/oktell.types'

import { oktell } from '@/core/realisations/oktell.realisation'

import { useMaska } from '@/common/composable/useMaska'
import useNotifications from '@/common/composable/useNotifications'

export const useOktellStore = defineStore('oktell-store', () => {
    const is_client_loading = ref(false)
    const is_client_failed = ref(false)
    const is_have_whatsapp = ref(false)

    const client = ref(null) as Ref<OktellClient | null>

    const route = useRoute()
    const router = useRouter()

    const { unmaskNumbers } = useMaska()
    const notifications = useNotifications()

    const checkWhatsapp = async (phone: string) => {
        try {
            const response = await oktell.isHaveWhatsapp(unmaskNumbers(phone))

            if (response.data.chatId) {
                is_have_whatsapp.value = true
            }
        } catch (error) {
            console.error(error)
            is_have_whatsapp.value = false
        }
    }

    const loadClient = async (phone: string | null) => {
        if (!phone) return

        try {
            is_client_loading.value = true

            const response = await oktell.getClientByPhone(phone)
            client.value = response.data

            if (route.path === '/oktell' || route.path === '/oktell/') {
                router.push({ path: `/oktell/clients`, query: route.query })
            }
        } catch (error) {
            console.error(error)

            // @ts-ignore
            if (error && error.status && error.status === 404) {
                if (route.path === '/oktell' || route.path === '/oktell/') {
                    return
                } else {
                    router.push({ path: `/oktell`, query: route.query })
                }

                return
            } else {
                is_client_failed.value = true
            }
        } finally {
            is_client_loading.value = false
        }
    }

    const resetStore = () => {
        is_client_failed.value = false
        client.value = null
    }

    return {
        is_client_loading,
        is_client_failed,
        is_have_whatsapp,
        client,
        checkWhatsapp,
        loadClient,
        resetStore,
    }
})
